import React from 'react'
import clsx from 'clsx'

import { useLayoutStyles, LayoutProps } from '../common'

type PlainLayoutProps = {
  headPage?: React.ReactNode
}

export const PlainLayout: React.FC<LayoutProps & PlainLayoutProps> = (
  props
) => {
  const classes = useLayoutStyles()

  return (
    <>
      {props.headPage && props.headPage}
      <div className={clsx(classes.root, props.className)}>
        {props.children}
      </div>
    </>
  )
}
